import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './index.css';
import FileUploader from './components/FileUploader';
import Contrato from './pages/Contrato';
import Error from './pages/Error';
import FotosPerfil from './pages/FotosPerfil';
import EvidenciaSubida from './pages/EvidenciaSubida';
import EvidenciaAlcance from './pages/EvidenciaAlcance';

function App() {
  return (
    <Router>
      <Routes>
        {/* Homepage with original FileUploader */}
        <Route path="/" element={
          <div className="min-h-screen bg-gray-100">
            <FileUploader />
          </div>
        } />
        
        {/* New contract upload page */}
        <Route path="/contrato" element={<Contrato />} />
        
        {/* Profile photos upload page */}
        <Route path="/fotosperfil" element={<FotosPerfil />} />
        
        {/* Activaciones -Evidencia subida page */}
        <Route path="/evidenciasubida" element={<EvidenciaSubida />} />
        
        {/* Activaciones -Alcance subida page */}
        <Route path="/evidenciaalcance" element={<EvidenciaAlcance />} />
        
        {/* Error page */}
        <Route path="/error" element={<Error />} />
      </Routes>
    </Router>
  );
}

export default App;